export default __webpack_public_path__ + "static/media/SH8.5367a935.png";